(function () {
  "use strict";

  function moneyFromCents(cents, moneyFormat) {
    var amount = (Number(cents) / 100).toFixed(2);
    if (!moneyFormat) return "$" + amount;
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)));
  }

  function routes() {
    return (window.theme && window.theme.routes) || {};
  }

  function moneyFormat() {
    return (window.theme && window.theme.moneyFormat) || "${{amount}}";
  }

  /* ----------------------------- Cart drawer ----------------------------- */

  var CartDrawer = {
    root: null,
    open: false,

    init: function () {
      this.root = document.querySelector("[data-cart-drawer]");
      if (!this.root) return;

      this.root.hidden = false;
      this.panel = this.root.querySelector("[data-cart-panel]");
      this.itemsEl = this.root.querySelector("[data-cart-items]");
      this.emptyEl = this.root.querySelector("[data-cart-empty]");
      this.footerEl = this.root.querySelector("[data-cart-footer]");
      this.subtotalEl = this.root.querySelector("[data-cart-subtotal]");
      this.countEl = this.root.querySelector("[data-cart-count]");
      this.toggleBtn = this.root.querySelector("[data-cart-toggle]");
      this.template = document.querySelector("[data-cart-item-template]");

      var self = this;
      this.toggleBtn.addEventListener("click", function () {
        self.toggle();
      });
      this.root.querySelector("[data-cart-close]").addEventListener("click", function () {
        self.close();
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") self.close();
      });

      this.refresh();
    },

    setOpen: function (open) {
      this.open = open;
      this.root.classList.toggle("is-open", open);
      this.toggleBtn.setAttribute("aria-expanded", open ? "true" : "false");
    },

    toggle: function () {
      this.setOpen(!this.open);
    },

    close: function () {
      this.setOpen(false);
    },

    show: function () {
      this.setOpen(true);
    },

    refresh: function () {
      var self = this;
      return fetch((routes().cart || "/cart") + ".js", {
        headers: { Accept: "application/json" },
      })
        .then(function (res) {
          if (!res.ok) throw new Error("Cart fetch failed");
          return res.json();
        })
        .then(function (cart) {
          self.render(cart);
          return cart;
        })
        .catch(function (err) {
          console.error(err);
        });
    },

    render: function (cart) {
      var count = cart.item_count || 0;
      this.toggleBtn.setAttribute(
        "aria-label",
        "Cart, " + count + " item" + (count === 1 ? "" : "s"),
      );

      if (count > 0) {
        this.countEl.hidden = false;
        this.countEl.textContent = String(count);
        this.emptyEl.hidden = true;
        this.footerEl.hidden = false;
      } else {
        this.countEl.hidden = true;
        this.emptyEl.hidden = false;
        this.footerEl.hidden = true;
        if (this.open) {
          /* keep drawer open so empty state is visible briefly */
        }
      }

      this.subtotalEl.textContent = moneyFromCents(cart.total_price || 0, moneyFormat());

      // Clear existing items (keep empty message node)
      Array.prototype.slice
        .call(this.itemsEl.querySelectorAll("[data-cart-item]"))
        .forEach(function (node) {
          node.remove();
        });

      var self = this;
      (cart.items || []).forEach(function (item) {
        self.itemsEl.appendChild(self.buildItem(item));
      });
    },

    buildItem: function (item) {
      var node = this.template.content.firstElementChild.cloneNode(true);
      var link = node.querySelector("[data-cart-item-link]");
      var title = node.querySelector("[data-cart-item-title]");
      var variant = node.querySelector("[data-cart-item-variant]");
      var image = node.querySelector("[data-cart-item-image]");
      var qty = node.querySelector("[data-cart-item-qty]");
      var price = node.querySelector("[data-cart-item-price]");

      node.dataset.lineKey = item.key;
      node.dataset.variantId = String(item.variant_id);
      link.href = item.url;
      title.href = item.url;
      title.textContent = item.product_title;
      variant.textContent = item.variant_title && item.variant_title !== "Default Title"
        ? "SIZE " + item.variant_title
        : "";
      qty.textContent = String(item.quantity);
      price.textContent = moneyFromCents(item.final_line_price, moneyFormat());

      if (item.image) {
        image.src = item.image;
        image.alt = item.product_title || "";
      } else {
        image.remove();
      }

      var self = this;
      node.querySelector("[data-cart-qty-dec]").addEventListener("click", function () {
        self.changeQuantity(item.key, item.quantity - 1);
      });
      node.querySelector("[data-cart-qty-inc]").addEventListener("click", function () {
        self.changeQuantity(item.key, item.quantity + 1);
      });
      node.querySelector("[data-cart-item-remove]").addEventListener("click", function () {
        self.changeQuantity(item.key, 0);
      });

      return node;
    },

    changeQuantity: function (key, quantity) {
      var self = this;
      var body = JSON.stringify({ id: key, quantity: Math.max(0, quantity) });
      return fetch((routes().cartChange || "/cart/change") + ".js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: body,
      })
        .then(function (res) {
          if (!res.ok) throw new Error("Cart update failed");
          return res.json();
        })
        .then(function (cart) {
          self.render(cart);
        })
        .catch(function (err) {
          console.error(err);
        });
    },

    addFromForm: function (form) {
      var self = this;
      var formData = new FormData(form);
      formData.delete("return_to");

      return fetch((routes().cartAdd || "/cart/add") + ".js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData,
      })
        .then(function (res) {
          if (!res.ok) throw new Error("Add to cart failed");
          return res.json();
        })
        .then(function () {
          return self.refresh();
        })
        .then(function () {
          self.show();
        });
    },

    /** Replace cart with this form's line, then open Shopify Checkout. */
    buyNowFromForm: function (form) {
      var formData = new FormData(form);
      formData.delete("return_to");

      return fetch("/cart/clear.js", {
        method: "POST",
        headers: { Accept: "application/json" },
      })
        .catch(function () {})
        .then(function () {
          return fetch((routes().cartAdd || "/cart/add") + ".js", {
            method: "POST",
            headers: { Accept: "application/json" },
            body: formData,
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error("Buy now failed");
          window.location.href = routes().checkout || "/checkout";
        });
    },
  };

  /* ----------------------------- Gallery / PDP ---------------------------- */

  function initGallery(root) {
    var gallery = root.querySelector("[data-ds-gallery]");
    if (!gallery) return;

    var slides = Array.prototype.slice.call(gallery.querySelectorAll("[data-gallery-slide]"));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll("[data-gallery-thumb]"));
    if (slides.length <= 1) return;

    var index = 0;

    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.hidden = !active;
        slide.classList.toggle("is-active", active);
      });
      thumbs.forEach(function (thumb, i) {
        var active = i === index;
        thumb.classList.toggle("is-active", active);
        if (active) thumb.setAttribute("aria-current", "true");
        else thumb.removeAttribute("aria-current");
      });
    }

    var prev = gallery.querySelector("[data-gallery-prev]");
    var next = gallery.querySelector("[data-gallery-next]");
    if (prev) prev.addEventListener("click", function () { show(index - 1); });
    if (next) next.addEventListener("click", function () { show(index + 1); });
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        show(Number(thumb.getAttribute("data-index")) || 0);
      });
    });
  }

  function findVariant(product, options) {
    if (!product || !product.variants) return null;
    return product.variants.find(function (variant) {
      return variant.options.every(function (opt, i) {
        return String(opt) === String(options[i]);
      });
    }) || null;
  }

  function initProduct(root) {
    var jsonEl = root.querySelector("[data-product-json]");
    if (!jsonEl) return;

    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var shippingCents = Number(root.getAttribute("data-shipping-cents") || 0);
    var format = moneyFormat();
    var forms = Array.prototype.slice.call(root.querySelectorAll("[data-ds-buy-form]"));
    var selectedOptions = (product.variants[0] && product.variants[0].options.slice()) || [];

    var sizeOptIndex = product.options.findIndex(function (name) {
      return String(name).toLowerCase() === "size" || String(name).toLowerCase() === "sizes";
    });
    if (sizeOptIndex < 0) sizeOptIndex = 0;
    if (product.options[sizeOptIndex]) {
      var values = product.options_with_values
        ? product.options_with_values[sizeOptIndex].values
        : [];
      if (values.indexOf("L") !== -1) selectedOptions[sizeOptIndex] = "L";
    }

    function syncUI(variant) {
      var unitCents = variant ? variant.price : Number(root.getAttribute("data-unit-cents") || 0);
      var qty = 1;
      var qtyInput = root.querySelector("[data-qty-input]");
      if (qtyInput) qty = Math.max(1, Number(qtyInput.value) || 1);

      var subtotal = unitCents * qty;
      var total = subtotal + shippingCents;

      root.querySelectorAll("[data-unit-price]").forEach(function (el) {
        el.textContent = moneyFromCents(unitCents, format);
      });
      root.querySelectorAll("[data-subtotal]").forEach(function (el) {
        el.textContent = moneyFromCents(subtotal, format);
      });
      root.querySelectorAll("[data-total]").forEach(function (el) {
        el.textContent = moneyFromCents(total, format);
      });

      var sizeLabel = selectedOptions[sizeOptIndex] || "L";
      root.querySelectorAll("[data-checksum]").forEach(function (el) {
        el.innerHTML =
          "SUBJECT — DARKSIDE MERCH DROP<br>CHECKSUM — DS-TEE-" +
          sizeLabel +
          "-" +
          qty;
      });

      var available = !variant || variant.available;
      root.querySelectorAll("[data-status]").forEach(function (el) {
        el.textContent = available ? "AVAILABLE" : "PRE-ORDER";
      });

      if (variant) {
        root.querySelectorAll("[data-variant-input]").forEach(function (input) {
          input.value = variant.id;
        });
        root.querySelectorAll("[data-sku-value]").forEach(function (el) {
          el.textContent = variant.sku || root.getAttribute("data-sku") || "";
        });
        root.querySelectorAll("[data-add-label]").forEach(function (el) {
          el.textContent = available ? "Add to Cart" : "Pre-order";
        });
        root.querySelectorAll("[data-buy-now]").forEach(function (el) {
          el.disabled = !available;
        });
      }

      root.querySelectorAll("[data-size-value]").forEach(function (btn) {
        var val = btn.getAttribute("data-size-value");
        var selected = String(val) === String(selectedOptions[sizeOptIndex]);
        btn.classList.toggle("is-selected", selected);
        btn.setAttribute("aria-pressed", selected ? "true" : "false");
      });
    }

    forms.forEach(function (form) {
      form.querySelectorAll("[data-size-value]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var position = Number(btn.getAttribute("data-option-position") || 1) - 1;
          selectedOptions[position] = btn.getAttribute("data-size-value");
          syncUI(findVariant(product, selectedOptions));
        });
      });

      form.querySelectorAll("[data-variant-id]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var id = Number(btn.getAttribute("data-variant-id"));
          var variant = product.variants.find(function (v) { return v.id === id; });
          if (!variant) return;
          selectedOptions = variant.options.slice();
          syncUI(variant);
        });
      });

      var qty = form.querySelector("[data-qty]");
      if (qty) {
        var input = qty.querySelector("[data-qty-input]");
        var dec = qty.querySelector("[data-qty-dec]");
        var inc = qty.querySelector("[data-qty-inc]");
        function bump(delta) {
          var next = Math.max(1, (Number(input.value) || 1) + delta);
          input.value = String(next);
          root.querySelectorAll("[data-qty-input]").forEach(function (el) {
            el.value = String(next);
          });
          syncUI(findVariant(product, selectedOptions));
        }
        if (dec) dec.addEventListener("click", function () { bump(-1); });
        if (inc) inc.addEventListener("click", function () { bump(1); });
        if (input) {
          input.addEventListener("change", function () {
            var next = Math.max(1, Number(input.value) || 1);
            input.value = String(next);
            root.querySelectorAll("[data-qty-input]").forEach(function (el) {
              el.value = String(next);
            });
            syncUI(findVariant(product, selectedOptions));
          });
        }
      }

      form.addEventListener("submit", function (event) {
        event.preventDefault();
        var btn = form.querySelector("[data-add-btn]");
        var label = btn && btn.querySelector("[data-add-label]");
        var previous = label ? label.textContent : "Add to Cart";
        if (btn) btn.disabled = true;
        if (label) label.textContent = "ADDING…";

        CartDrawer.addFromForm(form)
          .then(function () {
            if (label) label.textContent = "ADDED ✓";
            window.setTimeout(function () {
              if (label) label.textContent = previous;
              if (btn) btn.disabled = false;
            }, 1400);
          })
          .catch(function (err) {
            console.error(err);
            if (label) label.textContent = previous;
            if (btn) btn.disabled = false;
            form.submit();
          });
      });

      var buyNow = form.querySelector("[data-buy-now]");
      if (buyNow) {
        buyNow.addEventListener("click", function () {
          var label = buyNow.querySelector("[data-buy-label]");
          var previous = label ? label.textContent : "Buy Now";
          buyNow.disabled = true;
          if (label) label.textContent = "REDIRECTING…";

          CartDrawer.buyNowFromForm(form).catch(function (err) {
            console.error(err);
            if (label) label.textContent = previous;
            buyNow.disabled = false;
          });
        });
      }
    });

    syncUI(findVariant(product, selectedOptions));
  }

  document.addEventListener("DOMContentLoaded", function () {
    CartDrawer.init();
    document.querySelectorAll("[data-ds-product]").forEach(function (root) {
      initGallery(root);
      initProduct(root);
    });
  });
})();
